/* SILVIA - asistente en la web (FAQ + fichas de producto, sustituye a Edialog).
   Llama a window.FRIKY_SILVIA_API (POST /ask). Sin dependencias. */
(function () {
  'use strict';
  var API = window.FRIKY_SILVIA_API || 'https://frikyshop.fly.dev/api/silvia';
  // Avatar de Silvia (mismo chibi anime tipo Sailor Moon que el buscador). IDs propios (sv*) para no
  // colisionar con los del globo (fk*) cuando ambos widgets están en la misma página.
  var SILVIA_AV = '<svg class="silvia-face" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<defs>' +
    '<radialGradient id="svbg" cx="50%" cy="38%" r="70%"><stop offset="0" stop-color="#ffe9f6"/><stop offset="1" stop-color="#e7dcff"/></radialGradient>' +
    '<linearGradient id="svhair" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe58c"/><stop offset="1" stop-color="#f3bd45"/></linearGradient>' +
    '</defs>' +
    '<rect width="64" height="64" fill="url(#svbg)"/>' +
    '<circle cx="16" cy="17" r="8.5" fill="url(#svhair)"/><circle cx="48" cy="17" r="8.5" fill="url(#svhair)"/>' +
    '<circle cx="16" cy="17" r="3" fill="#e8a534"/><circle cx="48" cy="17" r="3" fill="#e8a534"/>' +
    '<path d="M14 44c-3-18 6-30 18-30s21 12 18 30c-1-8-6-12-6-12l-2 10-4-16s-3 12-8 12-8-12-8-12l-4 16-2-10s-5 4-6 12z" fill="url(#svhair)"/>' +
    '<ellipse cx="32" cy="40" rx="14.5" ry="15" fill="#ffe2cb"/>' +
    '<path d="M18 35c2-9 8-13 14-13s12 4 14 13c-5-4-9-5-9-5-1 4-3 5-5 5s-4-1-5-5c0 0-4 1-9 5z" fill="url(#svhair)"/>' +
    '<path d="M28 31h8l-1.4-2.4h-5.2z" fill="#ffd23f"/><circle cx="32" cy="30.5" r="2" fill="#e23b56"/>' +
    '<ellipse cx="25" cy="41.5" rx="3.9" ry="5" fill="#fff"/><ellipse cx="39" cy="41.5" rx="3.9" ry="5" fill="#fff"/>' +
    '<circle cx="25" cy="42.4" r="3" fill="#42306e"/><circle cx="39" cy="42.4" r="3" fill="#42306e"/>' +
    '<circle cx="26.2" cy="41" r="1" fill="#fff"/><circle cx="40.2" cy="41" r="1" fill="#fff"/>' +
    '<circle cx="20.5" cy="47" r="2.3" fill="#ffb0c4" opacity=".85"/><circle cx="43.5" cy="47" r="2.3" fill="#ffb0c4" opacity=".85"/>' +
    '<path d="M29 48.5q3 3 6 0" stroke="#c8687a" stroke-width="1.3" fill="none" stroke-linecap="round"/>' +
    '</svg>';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?'"])/g;
  function linkify(t) {
    var s = esc(t);
    // **negrita**
    s = s.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    // enlaces markdown [texto](url) → <a> (se protegen para no re-enlazar la URL)
    var links = [];
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, function (_m, txt, url) { links.push('<a href="' + url + '" target="_blank" rel="noopener">' + txt + '</a>'); return '' + (links.length - 1) + ''; });
    // URLs sueltas
    s = s.replace(URL_RE, function (u) { return '<a href="' + u + '" target="_blank" rel="noopener">' + u + '</a>'; });
    // restaurar enlaces markdown
    s = s.replace(/(\d+)/g, function (_m, i) { return links[+i]; });
    return s.replace(/\n/g, '<br>');
  }
  function seeAllBtn(term){ if(!term) return ''; return '<a class="silvia-seeall" href="/search?q='+encodeURIComponent(term)+'">Ver todos los productos →</a>'; }
  function productCards(products) {
    if (!products || !products.length) return '';
    return '<div class="silvia-prods">' + products.map(function (p) {
      return '<a class="silvia-prod" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') < 0 ? '?width=160' : '') + '" alt="">' : '') +
        '<span class="silvia-prod__t">' + esc(p.title) + '</span>' + (p.price ? '<span class="silvia-prod__p">' + Number(p.price).toFixed(2).replace('.', ',') + ' €</span>' : '') + '</a>';
    }).join('') + '</div>';
  }

  // opts: { el, productHandle, suggestions, variant('faq'|'expert'), title, subtitle, avatar, greeting, footer, live }
  function mountChat(opts) {
    var el = opts.el; if (!el) return;
    el.innerHTML =
      '<div class="silvia silvia--' + (opts.variant || 'faq') + '">' +
        '<div class="silvia__head"><span class="silvia__ava">' + (opts.avatar || '🎧') + '</span><div><div class="silvia__name">' + esc(opts.title) + '</div><div class="silvia__sub">' + esc(opts.subtitle) + '</div>' + (opts.live ? '<div class="silvia__live">● en línea</div>' : '') + '</div></div>' +
        '<div class="silvia__msgs" role="log"></div>' +
        (opts.suggestions && opts.suggestions.length ? '<div class="silvia__chips">' + opts.suggestions.map(function (s) { return '<button type="button" class="silvia__chip">' + esc(s) + '</button>'; }).join('') + '</div>' : '') +
        '<div class="silvia__form"><input class="silvia__input" type="text" placeholder="' + esc(opts.placeholder || FT('Haz cualquier pregunta…')) + '" autocomplete="off"><button class="silvia__send" type="button">Preguntar</button></div>' +
        (opts.footer ? '<div class="silvia__foot">' + esc(opts.footer) + '</div>' : '') +
      '</div>';
    var box = el.querySelector('.silvia__msgs'), form = el.querySelector('.silvia__form'), input = el.querySelector('.silvia__input');
    var history = []; // memoria de la conversación para acompañar progresivamente
    // Sesión COMPARTIDA con la burbuja friky-chat.js (misma clave localStorage) → el mismo cliente es
    // UN solo hilo en ATC, evita conversaciones duplicadas entre los dos widgets.
    var sessionId;
    try { sessionId = localStorage.getItem('friky_chat_sid'); if (!sessionId) { sessionId = 'fc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 9); localStorage.setItem('friky_chat_sid', sessionId); } }
    catch (e) { sessionId = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
    var started = false;
    function track(type, extra) {
      try {
        var body = JSON.stringify(Object.assign({ sessionId: sessionId, type: type, productHandle: opts.productHandle || undefined }, extra || {}));
        if (navigator.sendBeacon) { navigator.sendBeacon(API + '/event', new Blob([body], { type: 'application/json' })); }
        else { fetch(API + '/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }); }
      } catch (e) { /* silencioso */ }
    }
    function add(role, html) { var d = document.createElement('div'); d.className = 'silvia__msg silvia__msg--' + role; d.innerHTML = html; box.appendChild(d); box.scrollTop = box.scrollHeight; return d; }
    if (opts.greeting) add('bot', esc(opts.greeting));
    // Clics en enlaces de las respuestas (productos, colecciones, Club) → analítica de conversión.
    box.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a'); if (!a) return;
      var href = a.getAttribute('href') || '';
      var title = a.textContent || '';
      if (/\/products\//.test(href)) track('product_click', { url: href, title: title });
      else if (/\/collections\//.test(href)) track('collection_click', { url: href, title: title });
      else if (/club/i.test(href) || /club/i.test(title)) track('club_click', { url: href, title: title });
    });
    // Añade al carrito la acción que devuelve el backend (Silvia ya confirmó por texto).
    function doAddToCart(action) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: action.variantId, quantity: action.quantity || 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          add('bot', FT('✅ <b>Añadido al carrito.</b> <a href="/cart">Ver carrito</a>'));
          track('add_to_cart', { url: action.url, title: action.title });
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) { /* */ }
        })
        .catch(function () { add('bot', FT('No he podido añadirlo automáticamente 😕. Puedes añadirlo desde <a href="') + (action.url || '#') + '">la ficha del producto</a>.'); });
    }
    // Marca el carrito con la sesión de Silvia para atribuir la venta si el cliente compra.
    function markCart() {
      try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { silvia: '1', silvia_session: sessionId } }) }); } catch (e) { /* */ }
    }
    // Lee el total del carrito (para el empuje FT("te faltan X € para envío gratis")).
    function getCartTotal() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return (c && typeof c.total_price === 'number') ? c.total_price / 100 : undefined; })
        .catch(function () { return undefined; });
    }
    function ask(q) {
      if (!q.trim()) return;
      if (!started) { started = true; track('start'); markCart(); }
      add('user', esc(q)); input.value = '';
      var typing = add('bot', '<span class="silvia__typing"><i></i><i></i><i></i></span>');
      var sent = history.slice(-8);
      getCartTotal().then(function (cartTotal) {
      fetch(API + '/ask', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ question: q, productHandle: opts.productHandle || undefined, history: sent, sessionId: sessionId, cartTotal: cartTotal, lang: (document.documentElement.getAttribute('lang')||'') }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { typing.remove(); if (!res.ok) { add('bot', esc(res.j.error || 'Ahora mismo no puedo responder; un compañero del equipo te responde por aquí enseguida 🙏')); return; } var botMsg = add('bot', linkify(res.j.answer) + productCards(res.j.products) + seeAllBtn(res.j.seeAll)); var toTop=function(){ try { box.scrollTop += botMsg.getBoundingClientRect().top - box.getBoundingClientRect().top - 8; } catch (e) {} }; toTop(); setTimeout(toTop, 90); setTimeout(toTop, 300); history.push({ role: 'user', content: q }); history.push({ role: 'assistant', content: res.j.answer || '' }); if (history.length > 16) history = history.slice(-16); if (res.j.action && res.j.action.type === 'add_to_cart') doAddToCart(res.j.action); })
        .catch(function () { typing.remove(); add('bot', FT('Ups, error de conexión. Inténtalo de nuevo en un momento 🙏')); });
      });
    }
    var sendBtn = el.querySelector('.silvia__send');
    sendBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ask(input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); ask(input.value); } });
    el.querySelectorAll('.silvia__chip').forEach(function (c) { c.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ask(c.textContent); }); });
  }

  // FAQ curada dinámica: pinta las preguntas aprobadas en Diálogo, agrupadas por categoría.
  function renderFaqList(el) {
    fetch(API + '/faq').then(function (r) { return r.json(); }).then(function (d) {
      var groups = (d && d.groups) || [];
      if (!groups.length) return;
      var html = '<div class="silvia-faqlist">';
      groups.forEach(function (g) {
        if (!g.items || !g.items.length) return;
        html += '<div class="silvia-faqcat"><h3 class="silvia-faqcat__t">' + esc(g.category) + '</h3>';
        g.items.forEach(function (it) {
          html += '<details class="silvia-faqitem"><summary>' + esc(it.q) + '</summary><div class="silvia-faqa">' + linkify(it.a) + '</div></details>';
        });
        html += '</div>';
      });
      html += '</div>';
      el.innerHTML = html;
    }).catch(function () { /* silencioso */ });
  }

  // Teaser de Silvia en la HOME (justo bajo el banner). Fino y poco intrusivo: una tira
  // elegante que, al pulsarla, despliega el chat ahí mismo (personal shopper / regalos).
  // Engancha el chat a un teaser de Silvia YA presente en el DOM (lo renderiza la sección
  // "Banner Blog/News" dentro del bloque unificado). Rellena el avatar y abre el chat al pulsar.
  function wireHome(wrap) {
    var teaser = wrap.querySelector('.silvia-home__teaser');
    var chat = wrap.querySelector('.silvia-home__chat');
    if (!teaser || !chat) return;
    var ava = wrap.querySelector('.silvia-home__ava');
    if (ava && !ava.innerHTML.trim()) ava.innerHTML = SILVIA_AV;
    teaser.addEventListener('click', function () {
      teaser.style.display = 'none';
      chat.hidden = false;
      mountChat({
        el: chat, variant: 'faq', avatar: SILVIA_AV, title: 'Alex', subtitle: FT('Tu personal shopper friki'), live: true,
        greeting: FT('¡Hola! Soy Alex 👋 ¿Buscas un regalo o algo para ti? Cuéntame para quién es o qué te gusta y te ayudo a acertar.'),
        suggestions: [FT('Busco un regalo'), FT('Algo de anime'), FT('Novedades'), FT('Menos de 20 €'), FT('Recomiéndame')],
      });
      var inp = chat.querySelector('.silvia__input');
      var mobile = window.innerWidth <= 700; var sheetX = null;
      if (mobile) {
        // Móvil: el chat se abre como panel FIJO a pantalla completa (no inline) para que el teclado
        // no lo esconda bajo el header. Bloquea el scroll del fondo y añade botón de cerrar.
        chat.classList.add('silvia-sheet');
        document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
        sheetX = document.createElement('button'); sheetX.className = 'silvia-sheet-x'; sheetX.setAttribute('aria-label', 'Cerrar'); sheetX.innerHTML = '\u2715';
        chat.appendChild(sheetX);
      } else if (inp) { inp.focus(); }
      // Si el cliente abre pero NO interactúa y sigue haciendo scroll, se vuelve a plegar.
      var engaged = false;
      if (inp) inp.addEventListener('input', function () { if (inp.value.trim()) engaged = true; });
      var mo = new MutationObserver(function () { if (chat.querySelector('.silvia__msg--user')) engaged = true; });
      mo.observe(chat, { subtree: true, childList: true });
      var onScroll = null;
      function collapse() {
        if (onScroll) window.removeEventListener('scroll', onScroll);
        try { mo.disconnect(); } catch (e) {}
        if (mobile) { chat.classList.remove('silvia-sheet'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; if (sheetX) sheetX.remove(); }
        chat.hidden = true; chat.innerHTML = ''; teaser.style.display = '';
      }
      if (sheetX) sheetX.onclick = collapse;
      // En móvil (panel fijo) NO se pliega con el scroll de la página; solo en escritorio.
      if (!mobile) {
        var baseY = window.scrollY;
        onScroll = function () {
          if (engaged) { window.removeEventListener('scroll', onScroll); try { mo.disconnect(); } catch (e) {} return; }
          if (Math.abs(window.scrollY - baseY) > 140) collapse();
        };
        setTimeout(function () { baseY = window.scrollY; window.addEventListener('scroll', onScroll, { passive: true }); }, 400);
      }
    });
  }

  function initHome() {
    // 1) Si la sección liquid ya ha renderizado el teaser (bloque unificado), solo lo enganchamos.
    var existing = document.querySelector('.silvia-home');
    if (existing) { wireHome(existing); return; }
    // 2) Fallback (home sin la sección): inyectarlo encima de Blog/News, como antes.
    if (!document.body.classList.contains('index-template')) return;
    var main = document.querySelector('#MainContent'); if (!main) return;
    // Insertar JUSTO ENCIMA de la sección de Blog/News (friky_blog_news_banner) → bloque unido:
    // Silvia arriba, Blog y News debajo. Fallback: bajo el hero, o la primera sección.
    var sections = main.querySelectorAll('.shopify-section');
    var anchor = null, putBefore = true;
    for (var i = 0; i < sections.length; i++) {
      if (/blog[_-]?news/i.test(sections[i].id || '')) { anchor = sections[i]; putBefore = true; break; }
    }
    if (!anchor) {
      for (var j = 0; j < sections.length; j++) {
        if (/video[_-]?hero|slideshow|image[_-]?banner|\bhero\b|slider/i.test(sections[j].id || '')) { anchor = sections[j]; putBefore = false; break; }
      }
    }
    if (!anchor) { anchor = sections[0]; putBefore = true; }
    var wrap = document.createElement('div'); wrap.className = 'silvia-home silvia-home--news';
    wrap.innerHTML =
      '<div class="page-width">' +
        '<button type="button" class="silvia-home__teaser">' +
          '<span class="silvia-home__ava">' + SILVIA_AV + '</span>' +
          FT('<span class="silvia-home__txt"><b>¿Buscas un regalo o tienes una duda?</b>') +
          FT('<span class="silvia-home__sub">Habla con Alex, tu personal shopper friki 👋</span></span>') +
          '<span class="silvia-home__cta">' + FT('Preguntar') + '</span>' +
        '</button>' +
        '<div class="silvia-home__chat" hidden></div>' +
      '</div>';
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, putBefore ? anchor : anchor.nextSibling);
    else main.insertBefore(wrap, main.firstChild);
    wireHome(wrap);
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    initHome();
    var faqEl = document.querySelector('#friky-silvia-faq');
    if (faqEl) mountChat({
      el: faqEl, variant: 'faq', avatar: SILVIA_AV, title: 'Alex', subtitle: FT('Atención al cliente'), live: true,
      greeting: FT('¡Hola! Soy Alex 👋 Pregúntame lo que necesites: envíos, devoluciones, seguimiento de pedido, recomendaciones…'),
      footer: FT('Alex responde con la información de Frikytopia. Si algo no lo sabe, te pone en contacto con atención al cliente.'),
      suggestions: [FT('¿Cuánto tarda el envío?'), FT('¿Cómo hago una devolución?'), FT('Seguimiento de mi pedido'), FT('Métodos de pago'), FT('Recomiéndame un regalo friki')],
    });
    var faqListEl = document.querySelector('#friky-silvia-faqlist');
    if (faqListEl) renderFaqList(faqListEl);

    if (/\/products\//.test(window.location.pathname)) {
      var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
      var handle = m && m[1];
      if (handle) {
        var tries = 0;
        var place = function () {
          if (document.querySelector('.silvia-product')) return;
          // Justo debajo del bloque de pago (Comprar con Shop / Más opciones de pago).
          var pay = document.querySelector('.shopify-payment-button');
          var wrap = document.createElement('div'); wrap.className = 'silvia-product'; wrap.id = 'friky-silvia-product';
          if (pay && pay.parentNode) { pay.parentNode.insertBefore(wrap, pay.nextSibling); }
          else {
            var anchor = document.querySelector('.product__info-container, .product__info-wrapper, product-info, .product__info, product-form');
            if (!anchor) { if (tries++ < 12) return setTimeout(place, 350); return; }
            anchor.appendChild(wrap);
          }
          mountChat({
            el: wrap, productHandle: handle, variant: 'expert', avatar: SILVIA_AV,
            title: FT('Tu experto'), subtitle: FT('¿Alguna pregunta sobre este producto?'),
            greeting: FT('¿Qué quieres saber de este producto?'),
            suggestions: [FT('¿De qué material es?'), FT('¿Qué tamaño tiene?'), FT('¿Está disponible?'), FT('¿Es original?')],
          });
        };
        // espera a que aparezca el botón de pago (carga async)
        var wait = function () { if (document.querySelector('.shopify-payment-button') || tries++ >= 12) place(); else setTimeout(wait, 350); };
        wait();
      }
    }
  });
})();


